import {
    GameModeEnum,
    IGameContextViewModel
} from "../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {IServiceFactory} from "../../../services/service-factory.interface";
import {UndefinedString} from "../../../../common/types/nullable-types";

export class HeaderWelcomeButtonsAnalyticsSender {
    constructor(private readonly action: string,
                private readonly services: IServiceFactory,
                private readonly gameContext: IGameContextViewModel | undefined) {
    }

    sendAnalytics() {
        let category = 'Client_LoginButtons';
        let label: UndefinedString = undefined;
        if(this.gameContext) {
            category =  this.gameContext.gameMode === GameModeEnum.Demo ? 'Client_GameFrame_Anonymous' : 'Client_GameFrame_Real';
            label = this.gameContext.gameInfo.gameType + '_' + this.gameContext.gameInfo.title.replace(/ /g, '');
        }

        this.services.analytics.sendAnalytics(category, this.action, label);
    }
}